<template>
  <div>
    <!-- Chargement -->
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>

    <!-- TABS -->
    <v-tabs v-else icons-and-text centered slider-color="secondary" color="primary" dark>
      <v-tab href="#tab-1">
        {{ $t('description') }}
        <v-icon>description</v-icon>
      </v-tab>
      <v-tab href="#tab-2">
        {{ $tc('triggers', 2, {count: ''}) }}
        <v-icon>pages</v-icon>
      </v-tab>
      <v-tab href="#tab-3">
        {{ $t('behaviour') }}
        <v-icon>chat</v-icon>
      </v-tab>

      <!-- TAB 1 -->
      <v-tab-item value='tab-1' key='1'>
        <v-card>
          <!-- ACTIF -->
          <v-layout row wrap>
            <v-flex xs12 sm3>
              <v-subheader>{{ $t('status') }}</v-subheader>
            </v-flex>
            <v-flex xs12 sm3>
              <v-select
                :items="activ"
                v-model="filter.active"
                label="$t('scenarioActivated')"
                single-line
                menu-props="auto"
              ></v-select>
            </v-flex>
          </v-layout>
          <!-- NOM -->
          <v-layout row wrap>
            <v-flex xs12 sm3>
              <v-subheader>{{ $t('scenarioName') }}</v-subheader>
            </v-flex>
            <v-flex xs12 sm3>
              <v-text-field v-model="filter.name" :label="$t('scenarioThisName')"></v-text-field>
            </v-flex>
          </v-layout>
          <!-- COMMENTAIRE -->
          <v-layout row wrap>
            <v-flex xs12 sm3>
              <v-subheader>{{ $t('scenarioComment') }}</v-subheader>
            </v-flex>
            <v-flex xs12 sm3>
              <v-text-field v-model="filter.comment" :label="$t('comment')"></v-text-field>
            </v-flex>
          </v-layout>
          <!-- PRIORITY -->
          <v-layout row wrap>
            <v-flex xs12 sm3>
              <v-subheader>{{ $t('priority') }}</v-subheader>
            </v-flex>
            <v-flex xs12 sm3>
              <v-select
                :items="priotit"
                v-model="filter.level"
                :disabled="false"
                :label="$t('priority')"
                single-line
                menu-props="auto"
              ></v-select>
            </v-flex>
          </v-layout>
          <!-- FAMILLY -->
          <v-layout row wrap>
            <v-flex xs12 sm3>
              <v-subheader>{{$t('family')}}</v-subheader>
            </v-flex>
            <v-flex xs12 sm3>
              <v-select
                :items="famille"
                v-model="filter.family"
                :label="$t('family')"
                single-line
                menu-props="auto"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm3 v-show="filter.family === ''">
              <v-text-field v-model="filter.newfamily" :label="$t('newfamily')"></v-text-field>
            </v-flex>
          </v-layout>
          <!-- MULTIUSER -->
          <v-layout row wrap>
            <v-flex xs12 sm3>
              <v-subheader>{{$t('sharedWith')}}</v-subheader>
            </v-flex>
            <v-flex xs12 sm3>
              <v-select
                :items="multiUser"
                v-model="filter.multiUser"
                :label="$t('multiAgent')"
                single-line
                menu-props="auto"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-card>
      </v-tab-item>

      <!-- TAB 2 -->
      <v-tab-item value='tab-2' key='2'>
        <v-card id="tab-2">
          <v-list>
            <v-subheader inset>{{$t('triggersList')}}</v-subheader>
            <v-list-tile v-for="constraint in constraints" :key="constraint.title" avatar @click="openDialogEdit(constraint.id)">
              <v-list-tile-avatar>
                <v-icon medium class="primary--text" v-if="constraint.family == 'ecomm'">shopping_cart</v-icon>
                <v-icon medium class="primary--text" v-else-if="constraint.family == 'getplus'">extension</v-icon>
                <v-icon medium class="primary--text" v-else>explore</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>{{ dispFamilyName (constraint.family) }}</v-list-tile-title>
                <v-list-tile-sub-title v-if="constraint.condition != 'unvisited'">{{ dispTypeName (constraint.type) }} &nbsp;:&nbsp; {{ $t(constraint.condition) | cap }}&nbsp;{{ constraint.value }}</v-list-tile-sub-title>
                <v-list-tile-sub-title v-else>{{ dispTypeName (constraint.type) }} &nbsp; {{ $t('never') }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-menu bottom left>
                  <v-btn icon="icon" slot="activator" @mouseover.native="overMenu = true" @mouseleave.native="overMenu = false">
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile @click.stop="openDialogEdit(constraint.id)">
                      <v-list-tile-action>
                        <v-icon>edit</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{$t('editTrigger')}}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile @click="openDialogSupp(constraint.id)">
                      <v-list-tile-action>
                        <v-icon>delete</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{$t('deleteTrigger')}}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>

        </v-card>
        <div class="text-xs-right">
          <v-fab-transition>
            <v-btn
              dark
              class="secondary"
              fab
              @click.native.stop="openDialogCreate">
              <v-icon>add</v-icon>
            </v-btn>
          </v-fab-transition>
        </div>
      </v-tab-item>
      <!-- TAB 3 -->
      <v-tab-item value='tab-3' key='3'>
        <v-card flat id="tab-3">
          <!-- BEHAVIOUR -->
          <v-layout row wrap>
            <v-flex xs12 sm3>
                <v-subheader>{{$t('chooseBehav')}}</v-subheader>
              </v-flex>
            <v-flex xs12 sm3>
              <v-select
                :items="behaviour"
                v-model="filter.behaviour"
                :label="$t('toTrigg')"
                single-line
                menu-props="auto"
                @change="someHandler"
              ></v-select>
            </v-flex>
          </v-layout>
          <!-- MESSAGE INVIT -->
          <v-layout row wrap v-show="filter.behaviour === 'invitation'">
            <v-flex xs12 sm3>
              <v-subheader>{{$t('invitContent')}}</v-subheader>
            </v-flex>
            <v-flex xs12 sm7>
              <v-text-field v-model="filter.invitationMsg" :label="$t('bubbleMsg')" maxlength="255"></v-text-field>
            </v-flex>
          </v-layout>
          <!-- CHOIX PUSH -->
          <v-layout row wrap v-show="filter.behaviour === 'push'">
            <v-flex xs12 sm3>
              <v-subheader>{{$t('whichPush')}}</v-subheader>
            </v-flex>
            <v-flex xs12 sm5>
              <v-select
                :items="pushs"
                v-model="filter.pushId"
                :label="$t('choosePush')"
                single-line
                menu-props="auto"
              ></v-select>
            </v-flex>
          </v-layout>
          <!-- MOTIF DU CHAT -->
          <v-layout row wrap v-show="filter.behaviour === 'bot'">
            <v-flex xs12 sm3>
              <v-subheader>Choix du dialogue à lancer</v-subheader>
            </v-flex>
            <v-flex xs12 sm7>
              <v-text-field v-model="filter.botMotif" label="Dialogue" maxlength="255"></v-text-field>
            </v-flex>
          </v-layout>
        </v-card>
      </v-tab-item>
    </v-tabs>

    <!-- DIALOGUE CREATION -->
    <v-dialog v-model="showDialogCreate" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text">{{$t('addTrigger')}}</v-card-title>
        <v-card-text>
          <!-- FAMILLE -->
          <v-select
            :label="$t('type')"
            v-model="newConstraintDialog.family"
            :items="const_family">
          </v-select>
          <!-- TYPE -->
          <div v-if="newConstraintDialog.family === 'browse'">
            <v-select
              :label="$t('condition')"
              v-model="newConstraintDialog.type"
              :items="const_type">
            </v-select>
          </div>
          <!--<div v-else-if="newConstraintDialog.family === 'ecomm' && entLevel === '1'">-->
          <div v-else-if="newConstraintDialog.family === 'ecomm'">
            <v-select
              :label="$t('condition')"
              v-model="newConstraintDialog.type"
              :items="const_type_ecomm">
            </v-select>
          </div>
          <div v-else-if="newConstraintDialog.family === 'getplus'">
            <v-select
              :label="$t('condition')"
              v-model="newConstraintDialog.type"
              :items="const_type_getplus">
            </v-select>
          </div>
          <!-- CONDITION -->
          
          <div v-if="newConstraintDialog.type !== 'pageurlnb' && newConstraintDialog.type !== 'pageurlmoinsde' && newConstraintDialog.type !== 'pageurlplusde' && newConstraintDialog.type !== 'dayofweek' && newConstraintDialog.type !== 'aftertime'  && newConstraintDialog.type !== 'beforetime'">
            <div v-if="newConstraintDialog.type === 'hasphone' || newConstraintDialog.type === 'hasemail'">
              <v-select
                :label="$t('constraint')"
                v-model="newConstraintDialog.condition"
                :items="const_condition_ouinon">
              </v-select>
            </div>
            <div v-else-if="newConstraintDialog.type === 'iscutomer' || (newConstraintDialog.family === 'ecomm' && newConstraintDialog.type !== 'cartamount' && newConstraintDialog.type !== 'cartnb')">
              <v-select
                :label="$t('constraint')"
                v-model="newConstraintDialog.condition"
                :items="const_condition_page">
              </v-select>
            </div>
            <div v-else-if="newConstraintDialog.type === 'ismobile'">
              <v-select
                :label="$t('constraint')"
                v-model="newConstraintDialog.condition"
                :items="const_condition_mobile">
              </v-select>
            </div>
            <div v-else-if="editConstraintDialog.type === 'pageurl' || newConstraintDialog.type === 'pagetag' || newConstraintDialog.type === 'hasinnaf' || newConstraintDialog.type === 'inlabelnaf' || newConstraintDialog.type === 'notinlabelnaf' || newConstraintDialog.type === 'pageurlnb' || newConstraintDialog.type === 'pageurlmoinsde' || newConstraintDialog.type === 'pageurlplusde'">
              <v-select
                :label="$t('constraint')"
                v-model="newConstraintDialog.condition"
                :items="const_condition_contient">
              </v-select>
            </div>
            <div v-else-if="newConstraintDialog.type === 'isonpage' || newConstraintDialog.type === 'isnotonpage' || newConstraintDialog.type === 'raison' ">
              <v-select
                :label="$t('constraint')"
                v-model="newConstraintDialog.condition"
                :items="const_condition_contient_or_equal">
              </v-select>
            </div>
            <div v-else-if="newConstraintDialog.type === 'workforce'">
              <v-select
                :label="$t('constraint')"
                v-model="newConstraintDialog.condition"
                :items="const_condition_effectif">
              </v-select>
            </div>
            <div v-else-if="newConstraintDialog.type === 'pageduration' || newConstraintDialog.type === 'time'">
              <v-select
                :label="$t('constraint')"
                v-model="newConstraintDialog.condition"
                :items="const_condition_supinf">
              </v-select>
            </div>
            <div v-else-if="newConstraintDialog.type !== 'haschatted' && newConstraintDialog.type !== 'returning' && newConstraintDialog.type !== 'time'">
              <v-select
                :label="$t('constraint')"
                v-model="newConstraintDialog.condition"
                :items="const_condition_egalsupinf">
              </v-select>
            </div>
          </div>
          <!-- VALUE -->
          <div v-if="newConstraintDialog.type !== 'ismobile' && newConstraintDialog.type !== 'hasphone' && newConstraintDialog.type !== 'hasemail'">
            <div v-if="newConstraintDialog.type !== 'dayofweek' && newConstraintDialog.type !== 'aftertime' && newConstraintDialog.type !== 'beforetime'">
              <v-text-field :label="(newConstraintDialog.type === 'pageurlnb' || newConstraintDialog.type === 'pageurlmoinsde' || newConstraintDialog.type === 'pageurlplusde') ? 'contient dans URL' : $t('valueOfset')" v-model="newConstraintDialog.value" v-if="newConstraintDialog.condition !== 'unvisited' && newConstraintDialog.type !== 'haschatted' && newConstraintDialog.type !== 'returning' && newConstraintDialog.type !== 'hasgot' && newConstraintDialog.type !== 'hasnotgot'&& newConstraintDialog.type !== 'onmobile' && newConstraintDialog.type !== 'notonmobile' && newConstraintDialog.type !== 'workforce'"></v-text-field>
            </div>
            <div v-else>
              <v-select
                label="Time"
                v-model="newConstraintDialog.value"
                :items="newConstraintDialog.type === 'dayofweek' ? days : heure">
              </v-select>
            </div>
            <!-- TRIGGER -->
            <v-text-field :label="(newConstraintDialog.type === 'pageurlmoinsde' || newConstraintDialog.type === 'pageurlplusde') ? 'secondes' : 'nb de fois'" v-model="newConstraintDialog.trigger" v-if="newConstraintDialog.type === 'pageurlnb' || newConstraintDialog.type === 'pageurlmoinsde' || newConstraintDialog.type === 'pageurlplusde'"></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="showDialogCreate = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" flat @click.native="submitDialogCreate">{{ $t('add') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOGUE EDITION-->
    <v-dialog v-model="showDialogEdit" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('editTrigger') }}</v-card-title>
        <v-card-text>
          <!-- FAMILLE -->
          <v-select
            :label="$t('type')"
            v-model="editConstraintDialog.family"
            :items="const_family">
          </v-select>
          <!-- TYPE -->
          <div v-if="editConstraintDialog.family === 'browse'">
            <v-select
              :label="$t('condition')"
              v-model="editConstraintDialog.type"
              :items="const_type">
            </v-select>
          </div>
          <div v-else-if="editConstraintDialog.family === 'ecomm'">
            <v-select
              :label="$t('condition')"
              v-model="editConstraintDialog.type"
              :items="const_type_ecomm">
            </v-select>
          </div>
          <div v-else-if="editConstraintDialog.family === 'getplus'">
            <v-select
              :label="$t('condition')"
              v-model="editConstraintDialog.type"
              :items="const_type_getplus">
            </v-select>
          </div>
          <!-- CONDITION -->
          <div v-if="editConstraintDialog.type !== 'pageurlnb' && editConstraintDialog.type !== 'pageurlmoinsde' && editConstraintDialog.type !== 'pageurlplusde' && editConstraintDialog.type !== 'dayofweek' && editConstraintDialog.type !== 'aftertime'  && editConstraintDialog.type !== 'beforetime'">
            <div v-if="editConstraintDialog.type === 'hasphone' || editConstraintDialog.type === 'hasemail'">
              <v-select
                :label="$t('constraint')"
                v-model="editConstraintDialog.condition"
                :items="const_condition_ouinon">
              </v-select>
            </div>
            <div v-else-if="editConstraintDialog.type === 'iscutomer' || (editConstraintDialog.family === 'ecomm' && editConstraintDialog.type !== 'cartamount' && editConstraintDialog.type !== 'cartnb')">
              <v-select
                :label="$t('constraint')"
                v-model="editConstraintDialog.condition"
                :items="const_condition_page">
              </v-select>
            </div>
            <div v-else-if="editConstraintDialog.type === 'ismobile'">
              <v-select
                :label="$t('constraint')"
                v-model="editConstraintDialog.condition"
                :items="const_condition_mobile">
              </v-select>
            </div>
            <div v-else-if="editConstraintDialog.type === 'pageurl' || editConstraintDialog.type === 'pagetag' || editConstraintDialog.type === 'hasinnaf' || editConstraintDialog.type === 'inlabelnaf'  || editConstraintDialog.type === 'notinlabelnaf'">
              <v-select
                :label="$t('constraint')"
                v-model="editConstraintDialog.condition"
                :items="const_condition_contient">
              </v-select>
            </div>          
            <div v-else-if="editConstraintDialog.type === 'isonpage' || editConstraintDialog.type === 'isnotonpage' || newConstraintDialog.type === 'raison' ">
              <v-select
                :label="$t('constraint')"
                v-model="editConstraintDialog.condition"
                :items="const_condition_contient_or_equal">
              </v-select>
            </div>
            <div v-else-if="editConstraintDialog.type === 'workforce'">
              <v-select
                :label="$t('constraint')"
                v-model="editConstraintDialog.condition"
                :items="const_condition_effectif">
              </v-select>
            </div>
            <div v-else-if="editConstraintDialog.type === 'pageduration' || editConstraintDialog.type === 'time'">
              <v-select
                :label="$t('constraint')"
                v-model="editConstraintDialog.condition"
                :items="const_condition_supinf">
              </v-select>
            </div>
            <div v-else-if="editConstraintDialog.type !== 'haschatted' && editConstraintDialog.type !== 'returning' && editConstraintDialog.type !== 'time'">
              <v-select
                :label="$t('constraint')"
                v-model="editConstraintDialog.condition"
                :items="const_condition_egalsupinf">
              </v-select>
            </div>
          </div>
          <!-- VALUE -->
          <div v-if="editConstraintDialog.type !== 'ismobile' && editConstraintDialog.type !== 'hasphone' && editConstraintDialog.type !== 'hasemail'">
            <div v-if="editConstraintDialog.type !== 'dayofweek' && editConstraintDialog.type !== 'aftertime'  && editConstraintDialog.type !== 'beforetime'">
              <v-text-field :label="(editConstraintDialog.type === 'pageurlnb' || editConstraintDialog.type === 'pageurlmoinsde' || editConstraintDialog.type === 'pageurlplusde') ? 'contient dans URL' : $t('valueOfset')" v-model="editConstraintDialog.value" v-if="editConstraintDialog.condition !== 'unvisited' && editConstraintDialog.type !== 'haschatted' && editConstraintDialog.type !== 'returning' && editConstraintDialog.type !== 'hasgot' && editConstraintDialog.type !== 'hasnotgot'&& editConstraintDialog.type !== 'onmobile' && editConstraintDialog.type !== 'notonmobile' && editConstraintDialog.type !== 'workforce'"></v-text-field>
            </div>
            <div v-else>
              <v-select
                label="Time"
                v-model="editConstraintDialog.value"
                :items="editConstraintDialog.type === 'dayofweek' ? days : heure">
              </v-select>
            </div>
            <!-- TRIGGER -->
            <v-text-field :label="(editConstraintDialog.type === 'pageurlmoinsde' || editConstraintDialog.type === 'pageurlplusde') ? 'secondes' : 'nb de fois'" v-model="editConstraintDialog.trigger" v-if="editConstraintDialog.type === 'pageurlnb' || editConstraintDialog.type === 'pageurlmoinsde' || editConstraintDialog.type === 'pageurlplusde'"></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="showDialogEdit = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" flat @click.native="submitDialogEdit">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOGUE SUPPRESSION-->
    <v-dialog v-model="showDialogSupp" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('editTrigger') }}</v-card-title>
        <v-card-text>
          Voulez-vous supprimer ce déclancheur ?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          
          <v-btn color="primary" flat @click.native="deleteConstraint(declencheurSelected)">{{ $t('yes') }}</v-btn>
          <v-btn flat @click.native="showDialogSupp = false">{{ $t('no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="text-xs-right">
      <v-btn color="primary" @click.native="submit" 
        fixed
        bottom
        :disabled="alert"
        right>
          {{ $t('submit') }}<v-icon dark right>send</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import _ from 'lodash'
import { LEVEL } from '../../constants'
export default {
  props: ['id'],
  data () {
    return {
      /**
       * indique si une requête ajax en cours
       * @type {Boolean}
       */
      loading: false,
      /**
       * affiche/cache la fenetre de dialog de création
       * @type {Boolean}
       */
      showDialogCreate: false,
      showDialogEdit: false,
      showDialogSupp: false,
      declencheurSelected: false,
      /**
       * nouvelle contrainte à créer
       * @type {Object}
       */
      newConstraintDialog: {
        id: 1,
        family: 'browse',
        type: 'pageduration',
        condition: 'greater',
        value: '120',
        trigger: ''
      },
      editConstraintDialog: {
        family: 'browse',
        type: 'pageduration',
        condition: 'greater',
        value: '120',
        trigger: ''
      },

      constraints: [],
      filter: {
        id: '',
        name: '',
        user_id: '',
        lickey: '',
        comment: '',
        appear: '',
        notification: '',
        push: '',
        pushId: '',
        invitation: '',
        invitationMsg: '',
        bot: '',
        botMotif: '',
        c2c: '',
        active: '',
        usage: '',
        responseRate: '',
        level: '',
        family: '',
        called: '',
        success: '',
        creationTs: '',
        multiUser: '',
        constraints: '',
        behaviour: ''
      },
      overMenu: false,
      resAjx: null,
      resAjxFam: null,
      resAjxPush: null,

      priotit: [
        { text: '1', value: '1' },
        { text: '2', value: '2' },
        { text: '3', value: '3' },
        { text: '4', value: '4' },
        { text: '5', value: '5' },
        { text: '6', value: '6' },
        { text: '7', value: '7' },
        { text: '8', value: '8' },
        { text: '9', value: '9' },
        { text: '10', value: '10' }
      ],
      heure: [
        { text: '0h', value: '0' },
        { text: '1h', value: '3600' },
        { text: '2h', value: '7200' },
        { text: '3h', value: '10800' },
        { text: '4h', value: '14400' },
        { text: '5h', value: '18000' },
        { text: '6h', value: '21600' },
        { text: '7h', value: '25200' },
        { text: '8h', value: '28800' },
        { text: '9h', value: '32400' },
        { text: '10h', value: '36000' },
        { text: '11h', value: '39600' },
        { text: '12h', value: '43200' },
        { text: '13h', value: '46800' },
        { text: '14h', value: '50400' },
        { text: '15h', value: '54000' },
        { text: '16h', value: '57600' },
        { text: '17h', value: '61200' },
        { text: '18h', value: '64800' },
        { text: '19h', value: '68400' },
        { text: '20h', value: '72000' },
        { text: '21h', value: '75600' },
        { text: '22h', value: '79200' },
        { text: '23h', value: '82800' }
      ],
      days: [
        { text: 'Monday', value: '1' },
        { text: 'Tuesday', value: '2' },
        { text: 'Wednesday', value: '3' },
        { text: 'Thrusday', value: '4' },
        { text: 'Friday', value: '5' },
        { text: 'Saturday', value: '6' },
        { text: 'Sunday', value: '7' }
      ],
      activ: [
        { text: this.$t('active'), value: '1' },
        { text: this.$t('unactive'), value: '0' }
      ],
      multiUser: [
        { text: this.$t('onlyMe'), value: 'me' },
        { text: this.$t('allAgents'), value: 'all' }
      ],
      behaviour: [
        { text: _.upperFirst(this.$t('none')), value: '' },
        { text: this.$t('sendInvit'), value: 'invitation' },
        { text: this.$t('sendPush'), value: 'push', disabled: this.$store.state._User.entLevel !== '7' },
        { text: this.$t('sendC2C'), value: 'c2c', disabled: this.$store.state._Sites.siteSelected.LIC_CALLBACK_ACTIVATED === '0' },
        { text: this.$t('sendBot'), value: 'bot', disabled: this.$store.state._Sites.siteSelected.LIC_BOT_ACTIVATED === '0' },
        { text: this.$t('sendMeeting'), value: 'tirette_r', disabled: this.$store.state._Sites.siteSelected.LIC_RECALL_ACTIVATED === '0' },
        { text: this.$t('sendTiretteC2C'), value: 'tirette_c', disabled: this.$store.state._Sites.siteSelected.LIC_CALLBACK_ACTIVATED === '0' }
      ],
      const_family: [
        { text: this.$t('browsing'), value: 'browse' },
        { text: 'GetQuanty', value: 'getplus' }
      ],
      const_type: [
        { text: this.$t('constDuration'), value: 'time' },
        { text: this.$t('constNbPageSession'), value: 'nbpagesession' },
        { text: this.$t('constNbPage'), value: 'nbpagetoday' },
        { text: this.$t('constWeek'), value: 'nbpageweek' },
        { text: this.$t('constMonth'), value: 'nbpagemonth' },
        { text: 'Nb de pages visitées hier', value: 'nbpageyesterday' },
        { text: this.$t('constSamePage'), value: 'nbpageload' },
        { text: this.$t('constDiffPage'), value: 'nbpagediff' },
        { text: this.$t('constHisto'), value: 'pageurl' },
        { text: this.$t('constHistoAndNum'), value: 'pageurlnb' },
        { text: this.$t('constMoinsDe'), value: 'pageurlmoinsde' },
        { text: this.$t('constPlusDe'), value: 'pageurlplusde' },
        { text: this.$t('constDay'), value: 'dayofweek' },
        { text: this.$t('constAfter'), value: 'aftertime' },
        { text: this.$t('constBefore'), value: 'beforetime' },
        { text: this.$t('constOngoing'), value: 'isonpage' },
        { text: this.$t('constMobile'), value: 'ismobile' },
        { text: this.$t('constNoMore'), value: 'isnotonpage' },
        { text: this.$t('constTime'), value: 'pageduration' },
        { text: 'Returning Visiteur (au moins une visite antérieure à aujourd\'hui)', value: 'returning' },
        { text: this.$t('constChatted'), value: 'haschatted' }
      ],
      const_type_ecomm: [
        { text: this.$t('constCart'), value: 'pagecart' },
        { text: this.$t('constLogin'), value: 'pagelogin' },
        { text: this.$t('constDeliver'), value: 'pagedeliver' },
        { text: this.$t('constSummary'), value: 'pagesummary' },
        { text: this.$t('constPaiment'), value: 'pagepayment' },
        { text: this.$t('constValidation'), value: 'pagevalid' },
        { text: this.$t('constAmount'), value: 'cartamount' },
        { text: this.$t('constNbProd'), value: 'cartnb' },
        { text: this.$t('constCustomer'), value: 'iscutomer' }
      ],
      const_type_getplus: [
        { text: 'Info sur effectif', value: 'workforce' },
        { text: 'Info sur téléphone', value: 'hasphone' },
        { text: 'Info sur email', value: 'hasemail' },
        { text: 'Code NAF', value: 'hasinnaf' },
        { text: "L'activité (label NAF) contient le mot", value: 'inlabelnaf' },
        {
          text: "L'activité (label NAF) ne contient pas le mot",
          value: 'notinlabelnaf'
        },
        { text: 'Chaleur', value: 'chaleur' },
        { text: 'Raison Sociale', value: 'raison' }
      ],
      const_condition: [
        { text: this.$t('equal'), value: 'equal' },
        { text: this.$t('greater'), value: 'greater' },
        { text: this.$t('lower'), value: 'less' },
        { text: this.$t('never'), value: 'unvisited' },
        { text: this.$t('atLeastTimes'), value: 'visited' },
        { text: this.$t('containsString'), value: 'hasgot' },
        { text: this.$t('dontContain'), value: 'hasnotgot' },
        { text: this.$t('onMobile'), value: 'onmobile' },
        { text: this.$t('notOnMobile'), value: 'notonmobile' }
      ],
      const_condition_ouinon: [
        { text: this.$t('yes'), value: 'hasgot' },
        { text: this.$t('no'), value: 'hasnotgot' }
      ],
      const_condition_page: [
        { text: this.$t('never'), value: 'unvisited' },
        { text: this.$t('atLeastTimes'), value: 'visited' }
      ],
      const_condition_mobile: [
        { text: this.$t('onMobile'), value: 'onmobile' },
        { text: this.$t('notOnMobile'), value: 'notonmobile' }
      ],
      const_condition_contient: [
        { text: this.$t('containsString'), value: 'hasgot' }
      ],
      const_condition_contient_or_equal: [
        { text: this.$t('equal'), value: 'equal' },
        { text: this.$t('containsString'), value: 'hasgot' }
      ],
      const_condition_egalsupinf: [
        { text: this.$t('equal'), value: 'equal' },
        { text: this.$t('greater'), value: 'greater' },
        { text: this.$t('lower'), value: 'less' }
      ],
      const_condition_supinf: [
        { text: this.$t('greater'), value: 'greater' },
        { text: this.$t('lower'), value: 'less' }
      ],
      const_condition_effectif: [
        { text: '1 à 10', value: 'A' },
        { text: '10 à 50', value: 'B' },
        { text: '50 à 100', value: 'C' },
        { text: '100 à 250', value: 'D' },
        { text: '250 à 500', value: 'E' },
        { text: '500 à 1000', value: 'F' },
        { text: '1000 à 2000', value: 'G' },
        { text: '2000 et +', value: 'H' }
      ],
      famille: [],
      pushs: [],
      i: 0,
      dialogProgress: false,
      alert: false
    }
  },
  mounted () {
    // Possibilité d'avoir des filtres Ecommerce
    // en fonction du niveau de la licence
    if (this.level.rights === LEVEL.ENTREPRISE) {
      this.const_family.push({
        text: this.$t('ecomm'),
        value: 'ecomm'
      })
    }
    // Possibilité d'avoir des filtres navigation par tag API
    // en fonction du niveau de la licence
    if (this.level.rights === LEVEL.ENTREPRISE || this.level.rights === LEVEL.PRO) {
      this.const_type.push({
        text: this.$t('constTag'),
        value: 'pagetag'
      })
    }
    if (this.$store.state._User.entLevel === '5') {
      this.alert = true
    }
    this.loading = true
    let dataToGet = new window.FormData()
    dataToGet.append('id', this.id)

    this.axios
      .get('get/families.php')
      .then(response => {
        this.resAjxFam = response.data
      })
      .then(_ => {
        this.initFam()
      })
      .then(_ => {
        this.axios
          .get('get/pushs.php')
          .then(response => {
            this.resAjxPush = response.data
          })
          .then(_ => {
            this.initPush()
          })
      })
      .then(_ => {
        this.axios
          .post('get/filter.php', dataToGet, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          })
          .then(response => {
            this.resAjx = response.data
          })
          .then(_ => {
            this.loading = false
            this.initFil()
          })
      })
      .catch()
  },
  computed: {
    ...mapGetters('_User', ['user', 'level']),
    ...mapState('_User', ['entLevel'])
  },
  created () {
    /* eslint-disable */
    if (typeof (defautMotif) !== 'undefined') {
      defautMotif = 'target_filters'
    }
    else {
      setTimeout (function () {
        if (typeof (defautMotif) !== 'undefined') {
          defautMotif = 'target_filters'
        }
      }, 800);
    }
    /* eslint-enable */
  },
  methods: {
    initFam () {
      for (var i = 0; i < this.resAjxFam.length; ++i) {
        this.famille.push({ text: this.resAjxFam[i], value: this.resAjxFam[i] })
      }
      this.famille.push({ text: this.$t('newfamily'), value: '' })
    },
    initPush () {
      for (var j = 0; j < this.resAjxPush.length; ++j) {
        this.pushs.push({
          text: this.resAjxPush[j].PUSH_NAME,
          value: this.resAjxPush[j].PUSH_ID
        })
      }
    },
    initFil () {
      if (this.resAjx && this.resAjx !== '') {
        var _behav = ''
        if (this.resAjx.push === '1') {
          _behav = 'push'
        } else if (this.resAjx.invitation === '1') {
          _behav = 'invitation'
        } else if (this.resAjx.c2c === '1') {
          _behav = 'c2c'
        } else if (this.resAjx.bot === '1') {
          _behav = 'bot'
        }
        var _multi = 'me'
        if (this.resAjx.multiUser > 1) {
          _multi = 'all'
        }
        this.filter = {
          id: this.resAjx.id,
          name: this.resAjx.name,
          user_id: this.resAjx.user_id,
          lickey: this.resAjx.lickey,
          comment: this.resAjx.comment,
          appear: this.resAjx.appear,
          notification: this.resAjx.notification,
          push: this.resAjx.push,
          pushId: this.resAjx.pushId,
          invitation: this.resAjx.invitation,
          invitationMsg: this.resAjx.invitationMsg,
          bot: this.resAjx.invitation,
          botMotif: this.resAjx.botMotif,
          c2c: this.resAjx.c2c,
          active: this.resAjx.active,
          usage: this.resAjx.usage,
          responseRate: this.resAjx.responseRate,
          level: this.resAjx.level,
          family: this.resAjx.family,
          called: this.resAjx.called,
          success: this.resAjx.success,
          creationTs: this.resAjx.creationTs,
          multiUser: _multi,
          constraints: this.resAjx.constraints,
          behaviour: _behav
        }
        for (var k = 0; k < this.resAjx.constraints.length; ++k) {
          let _iconing = 'explore'
          if (this.resAjx.constraints[k].family === 'getplus') {
            _iconing = 'track_changes'
          } else if (this.resAjx.constraints[k].family === 'ecommerce') {
            _iconing = 'euro_symbol'
          }
          let info = this.resAjx.constraints[k].value
          let info2 = ''
          if (this.resAjx.constraints[k].trigger !== '') {
            info2 = ' : ' + this.resAjx.constraints[k].trigger
          }
          if (this.resAjx.constraints[k].type === 'dayofweek') {
            for (var l = 0; l < this.days.length; ++l) {
              if (this.days[l].value === this.resAjx.constraints[k].value) {
                info = this.days[l].text
              }
            }
            info = this.days[this.resAjx.constraints[k].value - 1].text
          }
          if (this.resAjx.constraints[k].type === 'aftertime' || this.resAjx.constraints[k].type === 'beforetime') {
            for (var m = 0; m < this.heure.length; ++m) {
              if (this.heure[m].value === this.resAjx.constraints[k].value) {
                info = this.heure[m].text
              }
            }
          }
          if (this.resAjx.constraints[k].type === 'ismobile') {
            info = ''
            info2 = ''
          }
          this.constraints.push({
            id: this.resAjx.constraints[k].id,
            condition: this.resAjx.constraints[k].condition,
            family: this.resAjx.constraints[k].family,
            type: this.resAjx.constraints[k].type,
            value: this.resAjx.constraints[k].value,
            trigger: this.resAjx.constraints[k].trigger,
            info: info,
            info2: info2,
            icon: _iconing
          })
        }
      }
      this.$store.commit('_Toolbar/SET_SUB_TITLE', this.filter.name)
    },
    /**
     *  Valide le formulaire et update la BDD et le fichier XML pour le front
     */
    submit () {
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('filter', JSON.stringify(this.filter))
      dataToPost.append('constraints', JSON.stringify(this.constraints))
      dataToPost.append('ENT_ID', this.$store.state._User.entId)

      // onboarding
      let steps = JSON.parse(this.$store.state._User.remainingSteps)
      // si cette étape est encore dans le tableau
      if (steps && typeof steps !== 'undefined' && steps.indexOf('INS_TARGET_FILTERS')) {
        // on l'efface du tableau
        steps.splice(steps.indexOf('INS_TARGET_FILTERS'), 1)
        // mise à jour du store _User
        this.$store.commit('_User/MAJ_PROGRESSION', {
          remainingSteps: JSON.stringify(steps)
        })
      }
      // steps.splice(steps.indexOf('INS_SETTINGS_CHAT'), 1)
      // this.$store.state._User.remainingSteps = JSON.stringify(steps)
      // this.$store.state._User.installProgress += 10

      this.axios
        .post('put/filter.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifSuccess'),
            context: 'success'
          })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifFailure'),
            context: 'error'
          })
        })
        .then(_ => {})
    },
    /**
     * ouvre la fenêtre de dialogue et initialise une nouvelle bibliothèque à créer
     */
    openDialogCreate () {
      this.showDialogCreate = true
    },
    /**
     * ouvre la fenêtre de dialogue et initialise une nouvelle bibliothèque à créer
     */
    openDialogEdit (_id) {
      if (!this.overMenu) {
        this.showDialogEdit = true
        for (let l = 0; l < this.constraints.length; ++l) {
          if (this.constraints[l].id === _id) {
            this.editConstraintDialog.id = this.constraints[l].id
            this.editConstraintDialog.family = this.constraints[l].family
            this.editConstraintDialog.type = this.constraints[l].type
            this.editConstraintDialog.condition = this.constraints[l].condition
            this.editConstraintDialog.value = this.constraints[l].value
            this.editConstraintDialog.trigger = this.constraints[l].trigger
          }
        }
      }
    },
    /**
     * valide la creation declencheur
     */
    submitDialogCreate () {
      this.showDialogCreate = false
      this.constraints.push({
        id: this.newConstraintDialog.id++,
        condition: this.newConstraintDialog.condition,
        family: this.newConstraintDialog.family,
        type: this.newConstraintDialog.type,
        value: this.newConstraintDialog.value,
        trigger: this.newConstraintDialog.trigger
      })
    },
    /**
     * valide l'edition du declencheur
     */
    submitDialogEdit () {
      this.showDialogEdit = false
      for (let l = 0; l < this.constraints.length; ++l) {
        if (this.constraints[l].id === this.editConstraintDialog.id) {
          this.constraints[l].family = this.editConstraintDialog.family
          this.constraints[l].type = this.editConstraintDialog.type
          this.constraints[l].condition = this.editConstraintDialog.condition
          this.constraints[l].value = this.editConstraintDialog.value
          this.constraints[l].trigger = this.editConstraintDialog.trigger
        }
      }
    },
    openDialogSupp (id) {
      this.showDialogSupp = true
      this.declencheurSelected = id
    },
    /**
     * ouvre le menudialog
     */
    deleteConstraint (_id) {
      for (let l = 0; l < this.constraints.length; ++l) {
        if (this.constraints[l].id === _id) {
          this.constraints.splice(l, 1)
          this.showDialogSupp = false
        }
      }
    },
    dispFamilyName (t) {
      for (let l = 0; l < this.const_family.length; ++l) {
        if (this.const_family[l].value === t) {
          return this.const_family[l].text
        }
      }
    },
    dispTypeName (t) {
      for (let m = 0; m < this.const_type.length; ++m) {
        if (this.const_type[m].value === t) {
          return this.const_type[m].text
        }
      }
      for (let n = 0; n < this.const_type_ecomm.length; ++n) {
        if (this.const_type_ecomm[n].value === t) {
          return this.const_type_ecomm[n].text
        }
      }
      for (let n = 0; n < this.const_type_getplus.length; ++n) {
        if (this.const_type_getplus[n].value === t) {
          return this.const_type_getplus[n].text
        }
      }
    },
    dispConditionName (t) {
      for (let l = 0; l < this.const_condition.length; ++l) {
        if (this.const_condition[l].value === t) {
          return this.const_condition[l].text
        }
      }
    },
    someHandler () {
      // alert('toto')
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/filters/Filter.vue